module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"signin":"Anmelden"},"en":{"signin":"Signin"}}')
  delete Component.options._Ctor
}
